/*
Author: Chathuraka Mallawa Arachchi
Date: 25/09/2024
Copyright © 2024 Infix!. All rights reserved.

Responsible for extending custom validations
*/

import { approval as approve } from '@/vendor/approvejs'
import formData from './formData'
import { Parser } from "expr-eval"
import Utility from '../Utility'

const cardExpiryDate = {
    expects: [],
    message: '',
    validate: function (value: any) {
        const reg = new RegExp(/^(0[1-9]|10|11|12)\/(1|2|3)[0-9]$/)
        return reg.test(value)
    },
}

const compare = {
    expects: ['comparison', 'field'],
    message: '{title} must be the same as {field}.',
    validate: function (value: any, pars: any) {
        const { comparison } = pars
        if (typeof comparison === 'function') {
            return value === comparison()
        }
        return value === comparison
    },
}

const CompareEmpty = {
    expects: ['CompareEmpty', 'field'],
    message: '{title} must be the same as {field}.',
    validate: function (value: any, pars: any) {
        //const reg = new RegExp(/^(0[1-9]|10|11|12)\/(1|2|3)[0-9]$/)
        //return reg.test(value)

        const { CompareEmpty } = pars
        if (typeof CompareEmpty === 'function') {
            const field = CompareEmpty()
            const fieldVal = formData.getFormDataByFieldName(field ? field : '')
            const evalE = !value && !fieldVal
            return !evalE
        }
        return ''
    },
}

const CompareEmptyList = {
    expects: ['CompareEmptyList', 'field'],
    message: '{title} must be the same as {field}.',
    validate: function (_value: any, pars: any) {
        const { CompareEmptyList } = pars
        let validationVal = true
        if (typeof CompareEmptyList === 'function') {
            const field = CompareEmptyList()
            const fieldVal = JSON.parse(field.replace(/'/g, '"'))
            fieldVal.forEach((fieldName: string) => {
                const fieldVal = formData.getFormDataByFieldName(
                    fieldName ? fieldName : ''
                )
                if (fieldVal !== 'Yes' && fieldVal !== 'No')
                    validationVal = false
            })
        }

        return validationVal
    },
}

const requiredIf = {
    expects: ['requiredIf'],
    message: 'Mandatory field.',
    validate: function (fieldValue: any, pars: any) {
        const { requiredIf } = pars
        const { expression, nodeName: fName } = requiredIf()
        if (expression) {
            try {
                // Use expr-eval to evaluate the condition
                const parser = new Parser()

                // Replace form field references with actual values
                const fieldHash = Utility.extractNodeHash(fName)
                let processedExpr = Utility.processFieldPlaceholders(expression, fieldHash, formData)
                const result = parser.evaluate(processedExpr)
                
                // If expression evaluates to true, field is required
                if (result) {
                    // If field is required and has no value, validation fails
                    if (!fieldValue || fieldValue.toString().trim() === '') {
                        return false;
                    }
                    // If field is required and has a value, validation passes
                    return true;
                }

                // If expression is false, field is not required, hence valid even if empty
                return true;
            } catch (error) {
                console.error('Error evaluating requiredIf condition:', error)
                return false;
            }
        }
        return true;
    },
}

approve.addTest(CompareEmptyList, 'CompareEmptyList')
approve.addTest(cardExpiryDate, 'cardExpiryDate')
approve.addTest(CompareEmpty, 'CompareEmpty')
approve.addTest(compare, 'compare')
approve.addTest(requiredIf, 'requiredIf')
